import AutoCompleteDto from "./AutoCompleteDto";
import {convertRecipientAddressesToString} from "../../util/Formatters";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import DbDraftEmail from "../../domain/DbDraftEmail";
import {ComposeEmailActions} from "../../actions/ComposeEmailActions";
import EmailAutoComplete from "../common/EmailAutoComplete";
import React from "react";

interface EmailAddressAutoCompleteProps {
    addresses: AutoCompleteDto[] | undefined;
    textAddress: string | undefined;
}

function normaliseAddresses(newAddresses: AutoCompleteDto[] | undefined, newTextAddress: string | undefined, existingAddresses: AutoCompleteDto[], onChange: (result: string) => void) {
    if (newAddresses || newTextAddress) {
        const addresses = [...(newAddresses ?? existingAddresses ?? [])];
        if (newTextAddress) {
            addresses.push({Address: newTextAddress, Name: ""});
        }
        onChange(convertRecipientAddressesToString(addresses));
    }
}

export const ToAddressAutoComplete = ({addresses, textAddress}: EmailAddressAutoCompleteProps) => {
    const dispatch = useAppDispatch();

    function onChangeDraftEmail(changes: Partial<DbDraftEmail>) {
        if (changes.ToAddresses) changes.ToTextAddress = "";
        normaliseAddresses(changes.ToAddresses, changes.ToTextAddress ?? textAddress ?? "", addresses ?? [], result => changes.To = result);

        // console.log("Change email TO", changes);
        dispatch(ComposeEmailActions.changeDraftEmail(changes));
    }

    return (
        <EmailAutoComplete
            label="To"
            autoFocus
            textValue={textAddress ?? ""}
            setTextValue={text => onChangeDraftEmail({ToTextAddress: text})}
            value={addresses ?? []}
            setValue={newValue => onChangeDraftEmail({ToAddresses: [...newValue]})}
        />

    );
}

export const CcAddressAutoComplete = ({addresses, textAddress}: EmailAddressAutoCompleteProps) => {
    const dispatch = useAppDispatch();

    const {showCC} = useAppSelector(s => s.compose.composeOptions);
    const hasCC = (addresses ?? []).length > 0 || !!textAddress;
    if (!showCC && !hasCC) {
        return null;
    }

    function onChangeDraftEmail(changes: Partial<DbDraftEmail>) {
        if (changes.CcAddresses) changes.CcTextAddress = "";
        normaliseAddresses(changes.CcAddresses, changes.CcTextAddress ?? textAddress ?? "", addresses ?? [], result => changes.Cc = result);

        // console.log("Change email CC", changes);
        dispatch(ComposeEmailActions.changeDraftEmail(changes));
    }

    return (
        <EmailAutoComplete
            label="CC"
            value={addresses ?? []}
            textValue={textAddress ?? ""}
            setTextValue={text => onChangeDraftEmail({CcTextAddress: text})}
            setValue={newValue => onChangeDraftEmail({CcAddresses: [...newValue]})}
        />
    );
}

export const BccAddressAutoComplete = ({addresses, textAddress}: EmailAddressAutoCompleteProps) => {
    const dispatch = useAppDispatch();

    const {showBCC} = useAppSelector(s => s.compose.composeOptions);
    const hasBCC = (addresses ?? []).length > 0 || !!textAddress;
    if (!showBCC && !hasBCC) {
        return null;
    }

    function onChangeDraftEmail(changes: Partial<DbDraftEmail>) {
        if (changes.BccAddresses) changes.BccTextAddress = "";
        normaliseAddresses(changes.BccAddresses, changes.BccTextAddress ?? textAddress ?? "", addresses ?? [], result => changes.Bcc = result);

        // console.log("Change email BCC", changes);
        dispatch(ComposeEmailActions.changeDraftEmail(changes));
    }

    return (
        <EmailAutoComplete
            label="BCC"
            value={addresses ?? []}
            textValue={textAddress ?? ""}
            setTextValue={text => onChangeDraftEmail({BccTextAddress: text})}
            setValue={newValue => onChangeDraftEmail({BccAddresses: [...newValue]})}
        />
    );
}
